import { PlainMessage } from "@bufbuild/protobuf";
import { Advisor, AdvisorStatus } from "protogen/common_pb";
import { UpdateAdvisorRequest } from "protogen/advisors_service_pb";
export type EphemeralAdvisor = {
  ref?: string;
  firstName?: string;
  lastName?: string;
  personalEmail?: string;
  personalPhone?: string;
  username?: string;
  advisorPhone?: string;
  sendIntroEmail?: boolean;
  externalLinks?: ExternalLink[];
  isProfilePublic?: boolean;
  shouldUpdateProfileImage?: boolean;
  timezone?: string;
  specialties?: string[];
  status?: AdvisorStatus;
  password?: string;
  address?: string;
  deactivationDate?: Date;
  emergencyContactName?: string;
  emergencyContactPhone?: string;
  emergencyContactRelationship?: string;
};

export type FormErrors = {
  [key: string]: string;
};

export type ExternalLink = {
  name: string;
  url: string;
};
const formatDateToMMDDYYYY = (date: Date): string => {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

export const updates = (
  advisor: Advisor,
  formData: EphemeralAdvisor,
): PlainMessage<UpdateAdvisorRequest> => {
  const formattedDeactivationDate = formData.deactivationDate
    ? formatDateToMMDDYYYY(formData.deactivationDate)
    : "";

  const specialtiesChanged = !compareArrayEqualityShallow(
    advisor.specialties,
    formData.specialties || [],
  );

  return {
    advisorRef: advisor.ref,
    updatedFirstName:
      advisor.firstName === formData.firstName ? "" : formData.firstName!,
    updatedLastName:
      advisor.lastName === formData.lastName ? "" : formData.lastName!,
    updatedPersonalEmail:
      advisor.personalEmail === formData.personalEmail
        ? ""
        : formData.personalEmail!,
    updatedPersonalPhone:
      advisor.personalPhone === formData.personalPhone
        ? ""
        : formData.personalPhone!,
    isProfilePublic:
      formData.isProfilePublic ?? advisor?.isProfilePublic ?? false,
    shouldUpdateProfileImage: formData.shouldUpdateProfileImage!,
    externalLinks: formData.externalLinks!,
    updatedTimezone:
      advisor.timezone == formData.timezone ? "" : formData.timezone!,
    updatedStatus:
      advisor.status === formData.status
        ? AdvisorStatus.NOT_SET
        : formData.status!,
    updatedSpecialties: specialtiesChanged ? formData.specialties! : [],
    shouldUpdateSpecialties: specialtiesChanged,
    updatedAddress:
      advisor.address === formData.address ? "" : formData.address!,
    shouldUpdateEmailNotifications: false,
    emailNotificationsEnabled: false,
    shouldUpdateForumNotifications: false,
    forumNotificationsEnabled: false,
    shouldUpdateMetadata: false,
    updatedMetadata: undefined,
    shouldUpdateNewClientOpportunitiesEnabled: false,
    newClientOpportunitiesEnabled: false,
    shouldUpdateHasSetupApp: false,
    hasSetupApp: false,
    shouldUpdateHasCompletedMatchmakingQuestionnaire: false,
    hasCompletedMatchmakingQuestionnaire: false,
    shouldUpdateHasCompletedOnboardingSession: false,
    hasCompletedOnboardingSession: false,
    shouldUpdateHasCompletedOutreachScorecard: false,
    hasCompletedOutreachScorecard: false,
    shouldUpdateSmsBotEnabled: false,
    smsBotEnabled: false,
    shouldUpdateProfilePublic: false,
    shouldUpdateEmergencyContact:
      advisor.emergencyContactName !== formData.emergencyContactName ||
      advisor.emergencyContactPhone !== formData.emergencyContactPhone ||
      advisor.emergencyContactRelationship !==
        formData.emergencyContactRelationship,
    updatedEmergencyContactName: formData.emergencyContactName ?? "",
    updatedEmergencyContactPhone: formData.emergencyContactPhone ?? "",
    updatedEmergencyContactRelationship:
      formData.emergencyContactRelationship ?? "",
    updatedDeactivationDate:
      advisor.deactivationDate === formattedDeactivationDate
        ? ""
        : formattedDeactivationDate,
  };
};

const compareArrayEqualityShallow = (a: string[], b: string[]): boolean => {
  if (a.length !== b.length) {
    return false;
  }
  return a.every((val, index) => val === b[index]);
};
